/**
 * Black-Swan Globar Directives
 *
 * @since: 2018-03-29
 * @author: kdydesign.kim
 */

import Vue from 'vue'

import {Authority} from './authority'
import Feature from './feature'
import Hide from './hide'
import Comma from './comma'
import Mask from './mask'
import TreeIFont from './tree-i-font'
import ClickOutside from './click-outside'

Vue.directive(Authority.name, Authority.hook)
Vue.directive(Feature.name, Feature)
Vue.directive(Hide.name, Hide)
Vue.directive(Comma.name, Comma)
Vue.directive(Mask.name, Mask)
Vue.directive(TreeIFont.name, TreeIFont)
Vue.directive(ClickOutside.name, ClickOutside)
